export type CommonStepId =
    | 'initial'
    | 'email_identification'
    | 'reset_password'
    | 'code_activation'
    | 'change_email'
    | 'profile_setup'
    | 'social_fallback';

export const DEFAULT_STEP_ID: CommonStepId = 'initial' satisfies CommonStepId;
